import { useEffect, useState } from 'react';
import { WizardStepData } from '@/components/wizard/types';

interface UseCategoryAutoSelectParams {
  category: string;
  isLoading: boolean;
  currentStepData: WizardStepData;
  blockedMessage: string | null;
  selectOption: (option: string) => void;
}

// Shared by PreFormWizardWithCategory and PreFormWizardWithSubCategory: once
// form data is loaded, auto-select the pre-seeded category once. Both wrap it
// with their own reset/retry handlers since those also need to reset state
// this hook doesn't own (e.g. subcategory state in the SubCategory variant).
export const useCategoryAutoSelect = ({
  category,
  isLoading,
  currentStepData,
  blockedMessage,
  selectOption,
}: UseCategoryAutoSelectParams) => {
  const [seeded, setSeeded] = useState(false);
  const [categoryError, setCategoryError] = useState<string | null>(null);

  useEffect(() => {
    if (!isLoading && !seeded) {
      setSeeded(true);
      if (
        currentStepData.options &&
        !currentStepData.options.includes(category)
      ) {
        setCategoryError(
          blockedMessage ??
            `No published templates found for category: "${category}"`
        );
        return;
      }
      selectOption(category);
    }
  }, [
    isLoading,
    seeded,
    category,
    selectOption,
    currentStepData.options,
    blockedMessage,
  ]);

  const resetCategorySeed = () => {
    setSeeded(false);
    setCategoryError(null);
  };

  return { seeded, categoryError, resetCategorySeed };
};
